import { DELIVERY_STATES } from '../../../lib/deliveryStates';

// The delivery states a rejection may transition from — «Rechazar recogida» records that the
// «Usuario» does not want the parcel. Matched case-insensitively (the wire is lowercase; older
// fixtures are TitleCase). Fail closed: an unrecognized state is not rejectable — never offer the
// action on a state we do not understand. Includes `collected`: opening the «buzón» auto-registers
// a pickup the «Usuario» may then decline, a correction back to `rejected`. Excludes `rejected`
// (already there), `non_collected` and `cancelled`. Spellings come from the canonical constants
// (backend-confirmed underscores); legacy hyphen/space variants are rejected rather than guessed.
const REJECTABLE_STATES = new Set<string>([
  DELIVERY_STATES.stored,
  DELIVERY_STATES.collected,
  DELIVERY_STATES.blocked,
  DELIVERY_STATES.expired,
]);

export function isRejectable(status: string): boolean {
  return REJECTABLE_STATES.has(status.toLowerCase());
}
